import * as React from "react";
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Form, { FormComponentProps } from 'antd/lib/form/Form';
import { ExpenseStatusEnum } from 'src/services/Enum/ExpenseStatusEnum';
import { WorkflowExpenseList } from 'src/components/common/ExpenseList/WorkflowExpenseList';
import { IExpenseDetail } from 'src/services/interfaces/Expense/IExpenseDetail';
import * as _ from 'lodash';
import { ModalCreatedExpense } from './ModalCreatedExpense';

const DemandedExpensesPage = (props: RouteComponentProps<any, any, IExpenseDetail[]> & FormComponentProps) => {
  const listStatus: ExpenseStatusEnum[] = [ExpenseStatusEnum.PENDING, ExpenseStatusEnum.APPROVED];
  const cardTitle = "Solicitações realizadas";

  return (
    <>
      <ModalCreatedExpense expenses={props.location.state} />
      <WorkflowExpenseList
        listStatus={listStatus}
        cardTitle={cardTitle}
      />
    </>);
}

export default withRouter(Form.create()(DemandedExpensesPage));



// WEBPACK FOOTER //
// ./src/pages/expenses/DemandedExpenses/DemandedExpenses.page.tsx